import { type OfferV11 } from '@redteclab/api/clients/bully'

/**
 * Shop-Apotheke seller id, used to identify Shop-Apotheke offers.
 */
const SAE_OFFER_TYPE = 'SAE'

export const productAccessorIsSaeOffer = (offer: OfferV11): boolean => {
  return offer.offerType?.toLowerCase() === SAE_OFFER_TYPE.toLowerCase()
}
